import React from 'react'
import { Typography } from 'antd'
import styled from 'styled-components'
import { XCircle } from 'react-feather'
import moment from 'moment'

import { FlexRow } from '../FlexboxReusables/FlexItems'
import { VerifyExamResponse } from './types'

export const renderExpiredCertificate = (data: VerifyExamResponse) => (
  <>
    <FlexRow>
      <Typography.Title level={2}>Das Zertifikat ist abgelaufen.</Typography.Title>
      <StyledXIcon size={30} />
    </FlexRow>
    <FlexRow justifyContent="flex-start">
      <Typography.Text>
      Das Zertifikat <b>{data?.courseName}</b> des Teilnehmers <b>{data?.participantLastName}, {data?.participantFirstName}</b> ist abgelaufen.
      </Typography.Text>
    </FlexRow>
    <FlexRow justifyContent="flex-start">
      <Typography.Text>
      Das Zertifikat war gültig bis zum: <b>{moment(data?.examFinishedAt).add(data?.examValidityMonths, 'months').format('DD.MM.YYYY')}</b>
      </Typography.Text>
    </FlexRow>
  </>
)

const StyledXIcon = styled(XCircle)`
  color: red;
  margin-left: 0.5em;
  margin-bottom: 0.5em;
`